<template>
    <div id="own-success-stories">
        <!--=====================================-->
        <!--=        Counter Up Area Start      =-->
        <!--=====================================-->
        <section class="section section-padding">
            <div class="container">
                <div class="section-heading">
                    <span class="subtitle primary bold">Casos de éxito.</span>
                    <h2 class="title font-weight-100">Descubre que han logrado otros <span class="bold">promotores.</span></h2>
                </div>
                <div class="row row-35 isotope-list">
                    <div class="col-md-4 project branding" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                        <div class="project-grid">
                            <div class="thumbnail text-align-last bg-gradient-green">
                                <h4 class="bold">Adios a tu jefe</h4>
                            </div>
                            <div class="content bg-color-light-gray">
                                <ul>
                                    <li><span class="bold">Inversionistas:</span> 1,078</li>
                                    <li><span class="bold">Inversión fija:</span> $8,267,417 mxn</li>
                                    <li><span class="bold">Ingreso pasivo (mensual):</span> $12,401 mxn</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 project mobile" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                        <div class="project-grid">
                            <div class="thumbnail text-align-last bg-gradient-green">
                                <h4 class="bold">Educación Financiera</h4>
                            </div>
                            <div class="content bg-color-light-gray">
                                <ul>
                                    <li><span class="bold">Inversionistas:</span> 1,259</li>
                                    <li><span class="bold">Inversión fija:</span> $4,835,755 mxn</li>
                                    <li><span class="bold">Ingreso pasivo (mensual):</span> $4,835 mxn</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 project branding" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300">
                        <div class="project-grid">
                            <div class="thumbnail text-align-last bg-gradient-green">
                                <h4 class="bold">Manolo</h4>
                            </div>
                            <div class="content bg-color-light-gray">
                                <ul>
                                    <li><span class="bold">Inversionistas:</span> 5,187</li>
                                    <li><span class="bold">Inversión fija:</span> $460,994 mxn</li>
                                    <li><span class="bold">Ingreso pasivo (mensual):</span> $230 mxn</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import formatHelper from "@mixins/formatHelper.js"
    export default {
        name: "OwnSuccesStories",
        mixins: [formatHelper],
        data: () => ({

        }),
    }
</script>

<style scoped>
.content {
    line-height: 2rem;
}

h4 {
    margin: 2rem;
}
</style>